<template>
  <v-container class="agency-container pt-10" color="#00000000">
    <v-row align="center">
      <v-col class="d-flex" cols="12"  v-if="!$vuetify.breakpoint.xs">
        <reset-button :gameID="gameID" class="setting-button">{{
          $t("homepage.reset.button")
        }}</reset-button>
      </v-col>
      <v-col class="d-flex"  v-if="showLocaleSwitcher">
        <locale-switcher :locales="locales" :currentLocale="currentLocale" class="setting-button" v-if="showLocaleSwitcher">{{
          $t("homepage.localeSwitcher.title")
        }}</locale-switcher>
      </v-col>
    </v-row>
    <router-link :to="{ name: `${this.gameID}-home` }" class="agency-logo">
      <img src="/stranger/assets/images/LOGO_55_PIXEL.png"  class="agency-logo-img"    />
      <p class="agency-text">
        55 INVESTIGATIONS
      </p>  
    </router-link>
  </v-container>
</template>
<script>
import LocaleSwitcher from "../LocaleSwitcher.vue";
import ResetButton from "../ResetButton.vue";

export default {
  props: {
    gameID: String,
    locales: Array,
    currentLocale: String
  },
  components: {
    LocaleSwitcher,
    ResetButton,
  },
  computed: {
    showLocaleSwitcher: function () {
      return this.$strangerStore.availableLocales.length > 1;
    }
  }
};
</script>
<style lang="scss" scoped>

@import '@/assets/css/stranger.scss';

.agency-logo {
  margin-top: 50px;
  position: absolute;
  height: 47px;
  top: 20px;
  left: 50%;
  transform: translate(-50%, 0%);
  text-align: center;
  text-decoration: none;


  img {
    height: 47px;  
    filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));  
  }

  .agency-text {
    text-align: center;
    text-decoration: none;
    color: $light-color;
    font-family: "Amiga4ever";
    font-size: 16px;
    width: 300px;
    margin-top: 10px;
  }  
}

@media (max-width: 600px) {
  .agency-logo {
    top:0px;

    .agency-text {
      font-size: 14px;
    }     
  }
}

.agency-container {
  background-color: rgba(0, 0, 0, 0);
}

.setting-button {
  font-family: "Amiga4ever";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0.06em;
  color: $light-color;
  text-transform: uppercase;
  margin-top: -80px;
}

.setting-button:hover {
  color: $accent-color;
}
</style>
